export default __webpack_public_path__ + "static/media/wewill.dcc400c7.mp3";